import React from 'react'
import PropTypes from 'prop-types'
import { Dialog } from '../Dialog/Dialog'
import { BASE_URL } from '../../../constants/Constants'

type DialogConfirmationProps = {
    title: string
    description: string
    showConfirmDialog: boolean
    setShowConfirmDialog: (open: boolean) => void
    handleConfirmPublish: React.MouseEventHandler<HTMLButtonElement> | undefined
}

function DialogConfirmation({title, description, showConfirmDialog, setShowConfirmDialog, handleConfirmPublish}: DialogConfirmationProps) {
  return (
    <Dialog open={showConfirmDialog} onClose={() => setShowConfirmDialog(false)}>
    <div className="w-full max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl py-4 sm:py-6 md:py-8 lg:py-10 xl:py-6 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 cursor-pointer">
      <div className="p-4 flex justify-center items-center">
        <img
          src={`${BASE_URL}/api/logo`}
          alt="Logo"
        />
      </div>
      <div>
        <p className='text-center text-red-500 text-2xl font-bold mt-5 mb-5'>{title}</p>
        <p className='text-center py-3 px-6 mb-6 fs-5'  >
          {description}
        </p>
        <div className="flex justify-center p-5 space-x-4">
          <button
            className="bg-primary px-6 py-2 font-bold text-white rounded-full"
            onClick={handleConfirmPublish}
          >
            Proceed
          </button>
          <button
            className="bg-gray-500 px-6 py-2 font-bold text-white rounded-full"
            onClick={() => window.location.reload()}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </Dialog>
  )
}


export default DialogConfirmation

